export const walkthroughUtils = {
  getFirstTimeLoggedInWalkthrough() {
    return [
      {
        currentPage: 0,
        image: '/assets/img/first-time-logged-in-walkthrough/step-one.png',
        header: 'Add Property Details',
        description:
          'Add details about your Hotel Group and Brands to onboard and manage multiple hotel properties.',
        btnImage: '/assets/img/first-time-logged-in-walkthrough/step-one-continue-btn-icon.png',
      },
      {
        currentPage: 1,
        image: '/assets/img/first-time-logged-in-walkthrough/step-two.png',
        header: 'Configure Hotels',
        description: 'Configure systems like PMS, GRMS, POS, etc. for your hotel properties.',
        btnImage: '/assets/img/first-time-logged-in-walkthrough/step-two-continue-btn-icon.png',
      },
      {
        currentPage: 2,
        image: '/assets/img/first-time-logged-in-walkthrough/step-three.png',
        header: 'Manage, Track & Optimized',
        description:
          'Control, manage and optimize your hotel’s information, guest experiences and service requests from a single console.',
        btnImage: '/assets/img/first-time-logged-in-walkthrough/step-three-continue-btn-icon.png',
      },
    ];
  },
};
